import { createFileRoute } from '@tanstack/react-router'
import { OrganizationCreditsSample } from '@/pages/OrganizationCreditsSample'

export const Route = createFileRoute(
  '/_authenticated/organizations/$id/credits/'
)({
  component: OrganizationCreditsSample,
})
